import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Teleport as _Teleport, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c8ac50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"visibility":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_slogan = _resolveComponent("t-slogan")!
  const _component_t_copyright = _resolveComponent("t-copyright")!
  const _component_t_portrait = _resolveComponent("t-portrait")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      id: "J-layout",
      ref: "wrap",
      class: _ctx.getClasses.wrap
    }, _ctx.$attrs, {
      style: _ctx.styles,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
    }), [
      (_ctx.isSlogan)
        ? (_openBlock(), _createBlock(_component_t_slogan, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.$slots.header)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            ref: "header",
            class: _normalizeClass(_ctx.getClasses.header),
            style: _normalizeStyle(_ctx.headerStyles)
          }, [
            _renderSlot(_ctx.$slots, "header", {}, undefined, true)
          ], 6))
        : _createCommentVNode("", true),
      (_ctx.$slots.content)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_ctx.getClasses.body),
            onScrollPassive: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
          }, [
            (_ctx.$slots.header)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "header", {}, undefined, true)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "content", {}, undefined, true),
            (_ctx.isFixed)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "J-footer-placeholder",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTapByPlaceholder && _ctx.onTapByPlaceholder(...args))),
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClasses.footerBody)
                  }, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ], 2),
                  (_ctx.isCopyright)
                    ? (_openBlock(), _createBlock(_component_t_copyright, {
                        key: 0,
                        lang: _ctx.lang,
                        "is-introduction": _ctx.isIntroduction
                      }, null, 8, ["lang", "is-introduction"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 34))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(_ctx.getClasses.body)
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 2)),
      _createElementVNode("div", {
        ref: "footer",
        class: _normalizeClass(_ctx.getClasses.footer),
        style: _normalizeStyle(_ctx.footerStyles)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClasses.footerBody)
        }, [
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ], 2),
        (_ctx.isCopyright)
          ? (_openBlock(), _createBlock(_component_t_copyright, {
              key: 0,
              lang: _ctx.lang,
              "is-introduction": _ctx.isIntroduction
            }, null, 8, ["lang", "is-introduction"]))
          : _createCommentVNode("", true)
      ], 6),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
      ]))
    ], 16),
    (_ctx.isOrientationChange)
      ? (_openBlock(), _createBlock(_component_t_portrait, {
          key: 0,
          lang: _ctx.lang
        }, null, 8, ["lang"]))
      : _createCommentVNode("", true)
  ], 64))
}